import { triggerEvent, getElementParents } from '../helpers/general';

// SEARCH
const elasticaSearch = document.querySelector('label[for=ElasticSearchForm_SearchForm_Search]');
if (elasticaSearch) {
  elasticaSearch.remove();
}

document.querySelectorAll('.nav-search form input[type=text]').forEach((input) => {
  input.value = '';
  input.setAttribute('placeholder', 'Zoeken');
});

document.querySelectorAll('.nav-search > a').forEach((link) => {
  link.addEventListener('click', (e) => {
    e.preventDefault();

    const form = link.nextElementSibling;

    if (form.dataset.active) {
      triggerEvent(form, 'submit');
      return;
    }

    document.querySelectorAll('#nav-bar .nav > ul').forEach((unorderedList) => {
      unorderedList.classList.add('faded');
    });

    setTimeout(() => {
      if (form.classList.contains('animate-hide')) {
        form.classList.replace('animate-hide', 'animate-show');
      } else {
        form.classList.add('animate-show');
      }

      form.dataset.active = true;
      triggerEvent(form.querySelector('input[type=text]'), 'focus');
    }, 200);
  });
});

document.querySelectorAll('.nav-search form input[type=text]').forEach((input) => {
  input.addEventListener('blur', () => {
    getElementParents(input, 'form').forEach((form) => {
      delete form.dataset.active;
      form.classList.replace('animate-show', 'animate-hide');

      setTimeout(() => {
        document.querySelectorAll('#nav-bar .nav > ul').forEach((unorderedList) => {
          unorderedList.classList.remove('faded');
        });
      }, 200);
    });
  });
});
